module.exports = __webpack_public_path__ + "assets/img/typeIcon-5.9f0d0fcb.svg";